var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ic_info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15592 1.33334C4.47403 1.33334 1.48926 4.31811 1.48926 8.00001C1.48926 11.6819 4.47403 14.6667 8.15592 14.6667C11.8378 14.6667 14.8226 11.6819 14.8226 8.00001C14.8226 6.2319 14.1202 4.53621 12.87 3.28596C11.6197 2.03572 9.92404 1.33334 8.15592 1.33334ZM8.82259 10.6667C8.82259 11.0349 8.52411 11.3333 8.15592 11.3333C7.78773 11.3333 7.48926 11.0349 7.48926 10.6667V7.33334C7.48926 6.96515 7.78773 6.66668 8.15592 6.66668C8.52411 6.66668 8.82259 6.96515 8.82259 7.33334V10.6667ZM7.48926 5.33334C7.48926 5.70153 7.78773 6.00001 8.15592 6.00001C8.52411 6.00001 8.82259 5.70153 8.82259 5.33334C8.82259 4.96515 8.52411 4.66668 8.15592 4.66668C7.78773 4.66668 7.48926 4.96515 7.48926 5.33334Z",
    fill: "#74C3E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.09e444e237a9cd06ec3092ca23614f06.svg";
export { ForwardRef as ReactComponent };